module.exports = __webpack_public_path__ + "img/loading.c6e6ed21.gif";